import 'construct-style-sheets-polyfill'; const styleSheet = new CSSStyleSheet(); styleSheet.replaceSync(`:host {
    font-family: var(--inv-font-family, 'Inter');
    font-size: var(--inv-input-text-font-size, 1em);
    --inv-grid-gutter-x: 0;
}

.input-container {
    display: flex;
    font-size: 1em;
    background: #fff;
    border-radius: 0.4em;
    border: 0.1em solid var(--inv-input-text-border-color, #aabaca);
}

input {
    font-family: inherit;
    width: 100%;
    border-radius: 0.4em;
    border: none;
    padding: 0.75em 0.8em;
    font-size: 1em;
    outline: none;
}

.input-container:hover {
    border: 0.1em solid var(--inv-input-hover-border-color, #0e4dab);
}

.input-container:focus-within {
    outline: none;
    border: 0.1em solid var(--inv-input-focus-border-color, #33c5d1);
}

.input-container.disabled {
    background: var(--inv-input-disabled-background, #f0f5f9);
    border: 0.1em solid var(--inv-input-disabled-border, #dbe1e7);
}

input::placeholder {
    color: var(--inv-input-placeholder-color, #6d809c);
}

.input-container.error {
    border: 0.1em solid var(--inv-input-error-border-color, #e22e59);
}

.input-suffix-container {
    display: flex;
    align-items: center;
    font-size: 1em;
    color: var(--inv-input-suffix-color, #aabaca);
    padding: 0 0.8em;
}

.end-addornment {
    right: 0;
    margin: 0.75em 1.58% 0.8em 0;
    z-index: 1;
}
`); export default styleSheet;